import { Flex, LoadingIndicator } from "@jsq/ds/core";

export const LoadingPage = () => (
  <Flex alignItems="center" justifyContent="center" css={{ height: "100vh" }}>
    <LoadingIndicator />
  </Flex>
);
